export default {
  nodeEnv: process.env.NODE_ENV,
  apiUrl: process.env.API_URL,
};
